import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  User,
  Briefcase,
  Wallet,
  Phone,
  FileText,
} from "lucide-react";

const DocumentUpload = () => {
  const navigate = useNavigate();

  const [documents, setDocuments] = useState({
    aadhaar: null,
    pan: null,
    experienceLetter: null,
  });

  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setDocuments({
      ...documents,
      [name]: files[0],
    });
  };

  const handleSubmit = async () => {
    const formData = new FormData();

    formData.append("aadhaar", documents.aadhaar);
    formData.append("pan", documents.pan);
    formData.append(
      "experience_letter",
      documents.experienceLetter
    );

    console.log("Documents Payload");

    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    alert("Employee Created Successfully");
  };

  return (
    <div className="p-8 bg-slate-50 min-h-screen">
      {/* Header */}
      <h1 className="text-5xl font-bold text-slate-900">
        Documents
      </h1>

      <p className="text-slate-500 mt-2 text-2xl">
        Step 5 of Employee Creation
      </p>

      {/* Stepper */}
      <div className="bg-white border border-slate-200 rounded-3xl p-8 mt-8 mb-8">
        <div className="flex items-center justify-between">

          {/* Personal */}
          <div className="flex flex-col items-center">
            <User size={28} className="text-green-600" />
            <span className="mt-2 text-green-600 font-medium">
              Personal
            </span>
          </div>

          <div className="flex-1 h-1 bg-green-500 mx-6 rounded-full"></div>

          {/* Employment */}
          <div className="flex flex-col items-center">
            <Briefcase size={28} className="text-green-600" />
            <span className="mt-2 text-green-600 font-medium">
              Employment
            </span>
          </div>

          <div className="flex-1 h-1 bg-green-500 mx-6 rounded-full"></div>

          {/* Salary */}
          <div className="flex flex-col items-center">
            <Wallet size={28} className="text-green-600" />
            <span className="mt-2 text-green-600 font-medium">
              Salary
            </span>
          </div>

          <div className="flex-1 h-1 bg-green-500 mx-6 rounded-full"></div>

          {/* Emergency */}
          <div className="flex flex-col items-center">
            <Phone size={28} className="text-green-600" />
            <span className="mt-2 text-green-600 font-medium">
              Emergency
            </span>
          </div>

          <div className="flex-1 h-1 bg-green-500 mx-6 rounded-full"></div>

          {/* Documents Active */}
          <div className="flex flex-col items-center">
            <FileText size={28} className="text-blue-600" />
            <span className="mt-2 text-blue-600 font-semibold">
              Documents
            </span>
          </div>

        </div>
      </div>

      {/* Form Card */}
      <div className="bg-white rounded-2xl border p-8">

        {/* Aadhaar */}
        <div className="mb-6">
          <label className="block text-sm font-medium mb-2">
            Aadhaar Card
          </label>

          <input
            type="file"
            name="aadhaar"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={handleFileChange}
            className="w-full border rounded-lg p-3"
          />
        </div>

        {/* PAN */}
        <div className="mb-6">
          <label className="block text-sm font-medium mb-2">
            PAN Card
          </label>

          <input
            type="file"
            name="pan"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={handleFileChange}
            className="w-full border rounded-lg p-3"
          />
        </div>

        {/* Experience Letter */}
        <div className="mb-8">
          <label className="block text-sm font-medium mb-2">
            Experience Letter
          </label>

          <input
            type="file"
            name="experienceLetter"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={handleFileChange}
            className="w-full border rounded-lg p-3"
          />
        </div>

        {/* Buttons */}
        <div className="flex justify-between">
          <button
            onClick={() =>
              navigate("/hr/employee/add/emergency")
            }
            className="px-6 py-3 border rounded-lg hover:bg-slate-50"
          >
            ← Previous
          </button>

          <button
            onClick={handleSubmit}
            className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Submit Employee
          </button>
        </div>

      </div>
    </div>
  );
};

export default DocumentUpload;